import { Global, css } from '@emotion/react'
/* prettier-ignore */
const GlobalStyle = () => {
	return <Global styles={css`

		html, body, div, span, applet, object, iframe,
		h1, h2, h3, h4, h5, h6, p, blockquote, pre,
		a, abbr, acronym, address, big, cite, code,
		del, dfn, em, img, ins, kbd, q, s, samp,
		small, strike, strong, sub, sup, tt, var,
		b, u, i, center,
		dl, dt, dd, ol, ul, li,
		fieldset, form, label, legend,
		table, caption, tbody, tfoot, thead, tr, th, td,
		article, aside, canvas, details, embed, 
		figure, figcaption, footer, header, hgroup, 
		menu, nav, output, ruby, section, summary,
		time, mark, audio, video {
			margin: 0;
			padding: 0;
			border: 0;
			font: inherit;
		}

		html {
			font-size: 62.5%; 
		}

		article, aside, details, figcaption, figure, 
		footer, header, hgroup, menu, nav, section {
			display: block;
		}

		html {
			font-size: 62.5%;
			height: 100%;
		}

		body {
			font-family: 'Pretendard', 'Arial', sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
				'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
				sans-serif;
			-webkit-font-smoothing: antialiased;
			-moz-osx-font-smoothing: grayscale;
			line-height: 1;
			height: 100%;
		}

		button {
			font-family: 'Pretendard', 'Arial', sans-serif, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
				'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
				sans-serif;
			cursor: pointer;
		}
		
		ol, ul {
			list-style: none;
		}

		blockquote, q {
			quotes: none;
		}

		blockquote:before, blockquote:after,
		q:before, q:after {
			content: '';
			content: none;
		}

		table {
			border-collapse: collapse;
			border-spacing: 0;
		}
		* {
			box-sizing: border-box;
		}

		#root {
			height: 100%;
		}

		.ant-notification-bottomLeft {
			left: 240px !important;
		}

		.motiners-notification {
			background: #2F80ED !important;
			width: 562px !important;
			padding: 8px 24px !important;
			border-radius: 8px !important;
		}

		.motiners-notification .ant-notification-notice-close {
			top: 8px !important;
			height: 24px !important;
		}

		.motiners-notification .ant-notification-notice-message {
			margin-bottom: 2px !important;
		}

		.motiners-notification .ant-typography {
			color: #fff !important;
		}

		.motiners-notification .ant-notification-notice-close {
			color: #fff !important;
		}
	`} />
}

export default GlobalStyle
